import { format, distanceInWords, differenceInHours, isValid, isToday } from 'date-fns';

export default {
  methods: {
    isDateStringValid(dateString = null) {
      if (!dateString || dateString === '0') {
        return false;
      }
      if (!isValid(new Date(dateString))) {
        return false;
      }
      return true;
    },
    formatDate(date) {
      if (!this.isDateStringValid(date)) { return ''; }
      return format(date, 'D MMM YYYY');
    },
    formatDateTime(date) {
      if (!this.isDateStringValid(date)) { return ''; }
      return format(date, 'D MMM YYYY HH:mm');
    },
    formatDateDistance(date, fallback = 'datetime') {
      if (!this.isDateStringValid(date)) { return ''; }
      const now = new Date();
      const diff = differenceInHours(now, date);
      if (Math.abs(diff) > 24 * 7) {
        if (fallback === 'date') {
          return this.formatDate(date);
        }
        return this.formatDateTime(date);
      }
      return distanceInWords(now, date, { addSuffix: true });
    },
    formatTimeOrDate(date) {
      if (!this.isDateStringValid(date)) { return ''; }
      if (isToday(date)) {
        return format(date, 'hh:mm A');
      }
      return this.formatDate(date);
    },
    getDurationInMinutes(date1, date2) {
      if (!this.isDateStringValid(date1)) {
        return '';
      }
      if (!this.isDateStringValid(date2)) {
        return '';
      }

      const diff = (new Date(date1)).getTime() -
        (new Date(date2)).getTime();
      const aMinute = 1e3 * 60;

      return `${Math.round(diff / aMinute)} minutes`;
    },
    getDurationValueInMinutes(date1, date2) {
      if (!this.isDateStringValid(date1)) {
        return 0;
      }
      if (!this.isDateStringValid(date2)) {
        return 0;
      }

      const diff = (new Date(date1)).getTime() -
        (new Date(date2)).getTime();
      const aMinute = 1e3 * 60;

      return Math.round(diff / aMinute);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/date.js